import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";


// SALES_By_Id
export const getEventSalesById = async (id) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.get(
        `${apiendpoints.MANAGE_SALES_BYID}?EventId=${id}`
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };

  // EVENT_SALES_ADD
export const addEventSales = async (data) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true,true));
      const response = await axioClient.post(
        apiendpoints.MANAGE_SALES_ADD,
        data
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };


  // Event_SALES_Delete
export const DeleteEventSales = async (id) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.post(
        `${apiendpoints.MANAGE_SALES_DELETE}?id=${id}`
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };

    // EVENT_Audience_ADD
export const addEventAudeience = async (data) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.post(
        apiendpoints.MANAGE_AUDIENCE,
        data
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };